import React, { useEffect, useState } from 'react';
import axios from '../../axiosConfig';
import calculateDistance from '../../services/distance'; // 导入 calculateDistance 函数
import TechnicianCard from '../../components/TechnicianCard';
import Footer from '../../components/Footer';
// import './TechnicianAll.css'; // 引入新的样式文件
import '../../styles/TechnicianAll.css';
import imgPrefix from '../../imgConfig'; // 导入 imgConfig.js
import { useNavigate } from 'react-router-dom';
import { Rate } from 'antd'; // 导入Rate组件用于显示星级评分
import { FilterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const TechnicianAll = () => {
  const [technicians, setTechnicians] = useState([]); // 附近技师数据
  const [userLocation, setUserLocation] = useState(null); // 用户位置
  const [selectedTechnician, setSelectedTechnician] = useState(null); // New state for selected technician
  const [activeFilter, setActiveFilter] = useState('综合推荐'); // 当前激活的筛选选项
  const { t, i18n } = useTranslation();

  const navigate = useNavigate(); // Define navigate using useNavigate hook

  useEffect(() => {
    setActiveFilter(t('technicians.comprehensive'));
  }, [t, i18n.language]);

  // 获取用户位置
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error('Error getting user location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, []);

  // 获取全部技师
  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    axios
      .get(`/jiaolianxinxi/autoSort?lang=${currentLang}`)
      .then((response) => {
        if (response.data.code === 0) {
          console.log("jiaolianxinxi response.data",response.data);
          
          setTechnicians(response.data.data.list);
        } else {
          console.error('Error fetching technicians:', response.data.msg);
        }
      })
      .catch((err) => console.error('Error fetching technicians:', err));
  }, [i18n.language]);

  // 筛选选项点击处理
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    // 这里可以添加实际筛选逻辑
  };

  // 生成随机店铺名称
  const getRandomShop = () => {
    const shops = [
      t('technicians.shopA'),
      t('technicians.shopB'),
      t('technicians.shopC'),
      t('technicians.shopD'),
      t('technicians.shopE'),
    ].filter(Boolean);
    return shops[Math.floor(Math.random() * shops.length)] || t('technicians.shopDefault');
  };

  return (
    <div className="technician-list-page">
      {/* 筛选栏 */}
      <div className="filter-bar">
        <div 
          className={`filter-item ${activeFilter === t('technicians.comprehensive') ? 'active' : ''}`}
          onClick={() => handleFilterClick(t('technicians.comprehensive'))}
        >
          {t('technicians.comprehensive')} ▼
          
        </div>
        <div 
          className={`filter-item ${activeFilter === t('technicians.female') ? 'active' : ''}`}
          onClick={() => handleFilterClick(t('technicians.female'))}
        >
          {t('technicians.female')}
        </div>
        <div 
          className={`filter-item ${activeFilter === t('technicians.male') ? 'active' : ''}`}
          onClick={() => handleFilterClick(t('technicians.male'))}
        >
          {t('technicians.male')}
        </div>
        <div className="filter-item filter-advanced">
          {t('technicians.filter')} <FilterOutlined />
        </div>
      </div>

      <div className="technician-list">
        <ul>
          {technicians.map((technician) => {
            // 假设所有技师的位置是固定的
            const technicianLat = 39.9042; // 技师的纬度
            const technicianLng = 116.4074; // 技师的经度
            const distance = userLocation
              ? calculateDistance(
                  userLocation.latitude,
                  userLocation.longitude,
                  technicianLat,
                  technicianLng
                ).toFixed(1)
              : Math.floor(Math.random() * 10).toFixed(1); // 随机距离

            // 模拟数据 - 实际应用中应该从API获取
            const age = technician.age || Math.floor(Math.random() * 15) + 25; // 随机生成25-40岁
            const hometownOptions = [
              t('technicians.hometownShandong'),
              t('technicians.hometownHebei'),
              t('technicians.hometownXinjiang'),
              t('technicians.hometownHenan'),
              t('technicians.hometownShanxi'),
            ].filter(Boolean);
            const hometown = hometownOptions[Math.floor(Math.random() * hometownOptions.length)] || '';
            const reviewCount = Math.floor(Math.random() * 300) + 4;
            const shop = getRandomShop();
            const goodRatePercentage = Math.floor(Math.random() * 3) + 98; // 随机生成98%-100%好评率
            
            // 每个技师都是"今日可约"，时间固定为"22:00"
            
            return (
              <li key={technician.id} className="technician-item"
                onClick={() => {
                  setSelectedTechnician(technician);
                  navigate(`/technician/${technician.jiaolianbianhao}`, {
                    state: {
                      technician,
                    },
                  });
                }}
              >
                <div className="technician-avatar-container">
                  <img
                    src={`${imgPrefix}/${technician.jiaoliantupian}`}
                    alt={technician.jiaolianxingming}
                    className="technician-avatar"
                  />
                </div>
                <div className="technician-details">
                  <div className="technician-header">
                    <h2 className="technician-name">{technician.jiaolianxingming}</h2>
                    <div className="booking-status">
                      <span className="today-available">{t('technicians.todayAvailable')}</span>
                      <span className="booking-time">22:00</span>
                    </div>
                  </div>
                  
                  <div className="technician-info-row">
                    <span className="technician-age">{t('technicians.age', { value: age })}</span>
                    <span className="technician-hometown">{t('technicians.hometown', { value: hometown })}</span>
                    <span className="technician-job">{t('technicians.roleTherapist')}</span>
                    {technician.jiaoliandengji === '高级' && <span className="technician-badge">券</span>}
                  </div>
                  
                  <div className="rating-container">
                    <div className="stars">
                      <Rate disabled defaultValue={4.5} allowHalf /> 
                    </div>
                    <span className="review-count">{t('technicians.comments')}{reviewCount}</span>
                    <span className="good-rate">{t('technicians.goodRate')}{goodRatePercentage}%</span>
                  </div>
                  
                  <p className="service-description">
                    {t('technicians.serviceDescription')}
                  </p>
                  
                  <div className="technician-footer">
                    <span className="shop-name">{shop}</span>
                    <span className="distance-info">{distance}km</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default TechnicianAll;
